module.exports = __webpack_public_path__ + "img/Partner_Sumsub.1f5a422e.svg";